import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { FiArrowRightCircle, FiBox } from "react-icons/fi";
import { handleError } from 'config/libraries';
import { MenuInformasi, MenuInformasiLainnya, MenuProfile } from 'master-data/menu';

export const Footer = () => {

    const [DataResponse, setDataResponse] = useState(null);

	useEffect(() => {
		const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/konfigurasi-website').then(function (response) {
            setDataResponse(response.data.data[0]);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponse(null);
        };
	}, []);
    
    return (
        <footer className="footer-section footer-two bg-gray text-white rel z-1">
            {(DataResponse != null) ? 
            <div className="container">
                <div className="call-to-action bg-blue bgs-cover text-white rel z-1">
                    <div className="row align-items-center">
                        <div className="col-xl-7 col-lg-6">
                            <div className="section-title mb-20">
                                <h2>Ada yang bisa kami bantu ?</h2>
                                <p>Kami siap melayani permintaan Anda</p>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6">
                            <div className="call-to-action-btns text-xl-right mb-20">
                                <Link to={'/home'} className="theme-btn style-two rmb-15">Masuk Website <FiArrowRightCircle className='hero-portal-icon' /></Link>
                                <Link to={'/informasi/bank-data'} className="theme-btn style-three rmb-15">Bank Data <FiBox className='hero-portal-icon' /></Link>
                            </div>
                        </div>
                    </div>
                    <img className="white-circle" src="/img/white-circle.png" alt="White Circle" />
                    <img className="white-dots slideUpRight" src="/img/white-dots.png" alt="shape" />
                    <img className="white-dots-circle slideLeftRight" src="/img/white-dots-circle.png" alt="shape" />
                </div>
                <div className="row justify-content-between">
                    <div className="col-3">
                        <div className="footer-widget about-widget">
                            <div className="footer-logo mb-20">
                                <img src={process.env.REACT_APP_SERVER_IMAGE_URL + DataResponse.logo_website} className="logo-portal-footer" alt="Logo" />
                            </div>
                            <p><span>{DataResponse.motto}</span></p>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="footer-widget link-widget">
                        <h4 className="footer-title">Profil</h4>
                        <ul className="list-style-two">
                            {
                                MenuProfile && MenuProfile.map((item, index) => {
                                    return (
                                        <li key={index} style={{ listStyle: 'square' }}><Link to={item.link}>{item.name}</Link></li>
                                    )
                                })
                            }
                        </ul>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="footer-widget link-widget">
                        <h4 className="footer-title">Informasi</h4>
                        <ul className="list-style-two">
                            {
                                MenuInformasi && MenuInformasi.map((item, index) => {
                                    return (
                                        <li key={index} style={{ listStyle: 'square' }}><Link to={item.link}>{item.name}</Link></li>
                                    )
                                })
                            }
                        </ul>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="footer-widget link-widget">
                        <h4 className="footer-title">Informasi Lainnya</h4>
                        <ul className="list-style-two">
                            {
                                MenuInformasiLainnya && MenuInformasiLainnya.map((item, index) => {
                                    return (
                                        <li key={index} style={{ listStyle: 'square' }}><Link to={item.link}>{item.name}</Link></li>
                                    )
                                })
                            }
                        </ul>
                        </div>
                    </div>
                </div>
                <div className="copyright-area text-center">
                <p>© Copyright { new Date().getFullYear() } Dinas Pendidikan. All rights reserved powered by <a className='text-footer-microdata' rel='noreferrer' target="_blank" href="http://microdataindonesia.co.id/">PT Microdata Indonesia</a></p>
                </div>
            </div>
            : ''}
            <img className="dots-shape" src="/img/dots.png" alt="Shape" />
            <img className="tringle-shape" src="/img/tringle.png" alt="Shape" />
            <img className="close-shape" src="/img/close.png" alt="Shape" />
            <img className="circle-shape" src="/img/circle.png" alt="Shape" />
        </footer>
    )
};